import {Component, computed, inject} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {AccordionFeedbackMediaProps, FeedbackMediaDialogData} from "./types/feedback-media-modal.types";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {FeedbackMediaModalService} from "./services/feedback-media-modal.service";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {accordionFeedbackMedia, feedbackMediaModalName} from "./configs/feedback-media-modal-config";
import {FeedbackMediaImageComponent} from "./components/feedback-media-image/feedback-media-image.component";
import {FeedbackMediaVideoComponent} from "./components/feedback-media-video/feedback-media-video.component";

@Component({
  selector: 'app-feedback-media-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    FeedbackMediaImageComponent,
    FeedbackMediaVideoComponent
  ],
  templateUrl: './feedback-media-modal.component.html',
  styleUrl: './feedback-media-modal.component.scss'
})
export class FeedbackMediaModalComponent extends BaseModalComponent {
  public feedbackMediaDialogData = inject<FeedbackMediaDialogData>(MAT_DIALOG_DATA);
  private feedbackMediaModalService: FeedbackMediaModalService = inject(FeedbackMediaModalService);

  public readonly accordionFeedbackMedia = accordionFeedbackMedia;
  public photoLinks = computed(() => this.feedbackMediaDialogData.media.photoLinks);
  public videoLinks = computed(() => this.feedbackMediaDialogData.media.videoLinks);

  public override ngOnInit(): void {
    this.modalStatesService.openModal(feedbackMediaModalName);
    this.feedbackMediaModalService.setImageUrlsToState(this.feedbackMediaDialogData.media.photoLinks);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(feedbackMediaModalName);
  }

  public isDisabledAccordion(type: string): boolean {
    return type === 'image' ? !this.photoLinks()?.length : !this.videoLinks()?.length;
  }

  public getTitle(accordion: AccordionFeedbackMediaProps): string {
    const count = accordion.type === 'image' ?
      this.photoLinks()?.length :
      this.videoLinks()?.length;

    return `${accordion.label} (${count || '-'})`;
  }
}
